import { TextField, ThemeProvider, Input, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import React, { useEffect } from 'react'
import Button from '@mui/material/Button';
import { useApi } from '../Store/ApiContext';
import { useTranslation } from 'react-i18next';
import joi from 'joi';
import $ from 'jquery';
import { enqueueSnackbar } from 'notistack';
import { constantsErrorMessage, validationErrorMessage } from '../../constants/global';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { set } from 'react-ga';

export default function ConfirmedMessageWithReason({ customTheme, togglePopUp, popupClose, id, endPoint, setRowData, requestDataRow, actionText = "delete", setData, data }) {
  const { removeUserApi, quickEditTable, showInvalidFeedback } = useApi();
  const { t, i18n } = useTranslation();
  console.log(actionText);

  const handleChangeCancellationReason = (event) => {
    setData({ ...data, cancellationReason: event.target.value });
  };

  const handleChangeAmountRefund = (event) => {
    setData({ ...data, amountRefund: event.target.value });
  };

  const handleChangePaymentMethod = (event) => {
    setData({ ...data, paymentMethod: event.target.value });
    console.log(data);
    
  };


  // function handleData() {
  //   let validBroadcastTime = false;
  //   for (let i = 0; i < paymentRows.length; i++) {
  //     if ((paymentRows.length === 1 && i == 0 && paymentRows[i].paymentMethod) || (i >= 0 && paymentRows[i].paymentMethod && paymentRows[i].amountRefund > 0)) {
  //       $(".requestPaymentsError").addClass("d-none");
  //       validBroadcastTime = true;
  //     } else {
  //       $(".requestPaymentsError").removeClass("d-none");
  //       validBroadcastTime = false;
  //     }
  //   }
  // }

  function validationData(newData) {
    const schema = joi.object().required().keys({
      reqStatus: joi.string().required(),
      cancellationReason: joi.string().when('reqStatus', {
        is: "cancelled",
        then: joi.required(),
        otherwise: joi.string().allow(null),
      }),
      amountRefund: joi.number().min(0).when('reqStatus', {
        is: "cancelled",
        then: joi.required(),
        otherwise: joi.number().allow(null),
      }),
      paymentMethod: joi.string().min(0).when('reqStatus', {
        is: "cancelled",
        then: joi.required(),
        otherwise: joi.string().allow(null),
      }),
    });
    return schema.validate(newData, { abortEarly: false })
  }

  const handleQuickEdit = async () => {
    const { error } = validationData(data);

    if (error) {
      enqueueSnackbar(
        <>
          {t(constantsErrorMessage)}
          <br />
          {t("Please enter the data correctly.")}
        </>,
        { variant: "error" }
      );
      return;
    }
    await quickEditTable(endPoint, data, id, setRowData);
    setData(null);
  };

  const sendWhatsappMessage = () => {
    const totalAmountFund = data?.amountRefund;

    if (!requestDataRow) return "";

    const message = `
      مرحبــا,  ${requestDataRow.reqClientName}

      هـذه رسالة تـأكـيـد إلـغـاء حـجـزكــم
      لوحدة رقم ${requestDataRow.unit.unitCode} من يوم ${moment(requestDataRow.reqFrom).format("DD/MM/YYYY")}
      مع استرداد قـيـمـة ${totalAmountFund} ج.م.
  `;
    return encodeURIComponent(message);
  }

  useEffect(() => {
    if (data?.reqStatus === "cancelled") {
      enqueueSnackbar(
        <>
          {t(constantsErrorMessage)}
          <br />
          {t("mustRefundTotalDeposits", { amountRefund: data?.amountRefund })}
        </>,
        { variant: "warning" }
      );
    }
  }, [data?.reqStatus])

  


  return (
    <>
      <div className='containerBox' onClick={(e) => { popupClose(e, "add-confirm"); }}>
        <div className='lightContainer' >
          <ThemeProvider theme={customTheme} >
            <div className='fs-4 text-center'>{t("Are you sure you want to", { action: t(actionText) })}</div>
            {data?.reqStatus === "cancelled" && <>
              <div className='p-2'>
                <TextField id='cancellationReason' className='textfield-input' value={data?.cancellationReason} multiline rows={2} inputProps={{ maxLength: 200 }} label={t("cancellationReason")} onChange={handleChangeCancellationReason} variant="standard" type="text" />
              </div>
              <div className='flex content-center items-end'>
                <div className='d-flex align-items-end p-2'>
                  <TextField id='amountRefund' className='textfield-input' inputProps={{ min: 0 }} variant="standard" type='number' value={data?.amountRefund} onChange={handleChangeAmountRefund} label={t("amountRefund")} />
                  <p className=''>{t("EGP")}</p>
                </div>
                <div className="flex-grow-1">
                  <div className='py-2 px-2'>
                    <FormControl className='textfield-input' variant="standard" >
                      <InputLabel id="demo-simple-select-standard-label">{t("paymentMethod")}</InputLabel>
                      <Select
                        MenuProps={{ disableScrollLock: true }}
                        labelId="demo-simple-select-standard-label"
                        id="paymentMethod"
                        value={data.paymentMethod}
                        defaultValue={"bankTransfer"}
                        onChange={handleChangePaymentMethod}
                      >
                        <MenuItem value={"bankTransfer"}>{t("bankTransfer")}</MenuItem>
                        <MenuItem value={"egyptianPost"}>{t("egyptianPost")}</MenuItem>
                        <MenuItem value={"wallet"}>{t("wallet")}</MenuItem>
                        <MenuItem value={"cash"}>{t("cash")}</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  {/* <div className="text-helper-invalid d-none">{t("pleaseSelectAPaymentMethod")}</div> */}
                </div>
                {requestDataRow &&
                  <button variant="text" className={'text-myPrimary fs-6 px-1 mx-0'}>
                    <a className='mx-2' target='_blank' href={`https://wa.me/${requestDataRow.client?.clientPhone || requestDataRow.rentingUser?.phoneNumber}?text=${sendWhatsappMessage()}`}>
                      <FontAwesomeIcon className=' cursor-pointer fs-5 text-success' icon={faWhatsapp} />
                    </a>
                  </button>
                }
              </div>
            </>}
            <div className='text-center mt-2'>
              <Button
                variant="contained"
                className='btn-myPrimaryLight m-3'
                onClick={() => togglePopUp("add-confirm")}
              >
                {t("Back")}
              </Button>
              <Button
                variant="contained"
                className='btn-myPrimary-delete'
                onClick={handleQuickEdit}
              >
                {t(actionText)}
              </Button>
            </div>
          </ThemeProvider>
        </div>
      </div>
    </>
  )
}
